import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage/session-storage.service';
import { UserService } from '../../../services/user/user.service';
import { StorageConstants } from '../../../shared/models/storage/storage-constants';

@Injectable({
  providedIn: 'root',
})
class AuthGuardService {
  constructor(
    private sessionStorageService: SessionStorageService,
    private userService: UserService
  ) {}

  async canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.sessionStorageService
        .get(StorageConstants.RM_ECOMMERCE_TOKEN)
        .then((res) => {
          if (res) {
            resolve(true);
          } else {
            this.userService.goToLogin('', false);
            resolve(false);
          }
        })
        .catch((_err) => {
          this.userService.goToLogin('', false);
          resolve(false);
        });
    });
  }
}

export const authGuard: CanActivateFn = (route, state) => {
  return inject(AuthGuardService).canActivate();
};
